// Small, tasteful BSN seal + website line for every printable download.
export const SITE = "brightstoriesnetwork.com";

export const sealSVG = (x, y, size) => `<g transform="translate(${x} ${y}) scale(${size / 120})">
  <defs>
    <linearGradient id="bsnGoldMark" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#F5D77F"/><stop offset="0.45" stop-color="#D4AF37"/><stop offset="1" stop-color="#996515"/></linearGradient>
  </defs>
  <circle cx="60" cy="60" r="58" fill="#102A45" stroke="url(#bsnGoldMark)" stroke-width="4"/>
  <circle cx="60" cy="60" r="49" fill="none" stroke="#D4AF37" stroke-width="1.5" opacity="0.7"/>
  <circle cx="60" cy="48" r="7" fill="#D4AF37"/>
  <text x="60" y="84" text-anchor="middle" font-family="Cinzel, Georgia, serif" font-weight="700" font-size="30" fill="#D4AF37">BSN</text>
</g>`;

export const brandLineSVG = (cx, y, color = "#8C6D23", size = 16) => `
  ${sealSVG(cx - 150, y - size + 4, size)}
  <text x="${cx - 150 + size + 6}" y="${y}" font-family="Georgia, serif" font-size="11" letter-spacing="0.5" fill="${color}">Bright Stories Network  ·  ${SITE}</text>`;

export const brandHTML = `<span style="display:inline-flex;align-items:center;gap:6px;font-family:Georgia,serif;font-size:11px;color:#8C6D23;letter-spacing:0.5px;margin-top:6px"><svg width="16" height="16" viewBox="0 0 120 120">${sealSVG(0, 0, 120)}</svg>Bright Stories Network · ${SITE}</span>`;
